import AxiosInstance from "./AxiosInstance";

// Get All Destinations
export const getAllUsers = async () => {
  try {
    const { data } = await AxiosInstance.get("/users");
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

// Login user
export const LoginApi = async ({ email, password }) => {
  try {
    const response = await AxiosInstance.post(`/users/login`, {
      email,
      password,
    });
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

// Create users
export const createusers = async (user) => {
  try {
    const { data } = await AxiosInstance.post("/users", user);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};
